import React, { useState } from "react";
import MaleICON from "../../images/VR1.jpeg";
import PersonICON from "../../images/SR.jpeg";
import SKImage from "../../images/SK.jpeg";
import DelNovaHomeImage from "../../images/DelNovaHomeImage.jpg";
import CommitmentIcon from "../../images/handshake_thick.png";
import DifferentiationIcon from "../../images/artificial-intelligence_thick.png";

export default function AboutUsRedesign() {
  const [selectedMember, setSelectedMember] = useState(null);

  const values = [
    {
      name: "Trustworthy",
      desc: "Delivering on our promises and building long-term alliances based on transparency, compliance, and integrity.",
      // Award Ribbon Icon
      icon: (
        <svg className="w-10 h-10 text-brand-teal" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="9" r="6" />
          <path d="M9 14.2L6 21.5l3.5-1.5 3.5 1.5-1.5-3.5" />
          <path d="M15 14.2l3 7.3-3.5-1.5-3.5 1.5 1.5-3.5" />
          <path d="M12 6.5l.8 1.6 1.8.2-1.3 1.3.3 1.8-1.6-.9-1.6.9.3-1.8-1.3-1.3 1.8-.2z" fill="currentColor" />
        </svg>
      ),
    },
    {
      name: "Commitment",
      desc: "Adhering to our core development timelines and ensuring that our formulations provide sustainable global healthcare growth, in competitive scenario.",
      // Handshake Icon
      icon: (
        <div
          className="w-10 h-10 text-brand-teal bg-current transition-colors duration-300"
          style={{
            maskImage: `url(${CommitmentIcon})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
            WebkitMaskImage: `url(${CommitmentIcon})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain"
          }}
        />
      ),
    },
    {
      name: "Quality iN Design",
      desc: "Developing robust, reproducible formulation processes that yield stable, bio-effective compositions right from inception.",
      // Glowing Lightbulb Icon
      icon: (
        <svg className="w-10 h-10 text-brand-teal" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .5 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
          <path d="M9 18h6" />
          <path d="M10 21h4" />
          <line x1="12" y1="2" x2="12" y2="4" />
          <line x1="4.9" y1="4.9" x2="6.3" y2="6.3" />
          <line x1="19.1" y1="4.9" x2="17.7" y2="6.3" />
          <line x1="2" y1="12" x2="4" y2="12" />
          <line x1="20" y1="12" x2="22" y2="12" />
          <line x1="6.3" y1="17.7" x2="4.9" y2="19.1" />
          <line x1="17.7" y1="17.7" x2="19.1" y2="19.1" />
        </svg>
      ),
    },
    {
      name: "Differentiation",
      desc: "Leveraging incremental Innovation and technological intelligence to craft unique drug delivery mechanisms that elevate patient care.",
      // Face profile with Brain Network Icon
      icon: (
        <div
          className="w-10 h-10 text-brand-teal bg-current transition-colors duration-300"
          style={{
            maskImage: `url(${DifferentiationIcon})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
            WebkitMaskImage: `url(${DifferentiationIcon})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain"
          }}
        />
      ),
    },
    {
      name: "Innovation",
      desc: "Pushing pharmaceutical boundaries to build “Patient centric” , simple, cost-effective, and highly reliable dosage solutions, for global populations.",
      // Shining Sun Icon
      icon: (
        <svg className="w-10 h-10 text-brand-teal" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
      ),
    },
  ];

  const team = [
    {
      name: "Vijayendrakumar Redasani",
      role: "Founder & CEO",
      image: MaleICON,
      bio: "Vijayendrakumar is a seasoned pharmaceutical professional with extensive expertise in generic and complex formulation development. Over his career, he has demonstrated outstanding technical leadership in driving numerous ANDA development projects to success. He provides strategic guidance for DelNova's core R&D activities and maintains a deep hands-on understanding of solid and liquid dosage forms, process scaling, and manufacturing requirements. His results-oriented work philosophy focuses on achieving major technical and business milestones through cross-functional teamwork.",
    },
    {
      name: "Shweta Redasani",
      role: "Co-Founder",
      image: PersonICON,
      bio: "Shweta is a science graduate with exceptional expertise in project negotiation, relationship management, and alliance coordination. Self-driven and results-oriented, she aligns DelNova's development timelines with the strategic requirements of global business partners. Her strong interpersonal and leadership skills help build solid corporate bridges, coordinate with technical and support divisions, and successfully execute short-, mid-, and long-term business strategies.",
    },
    {
      name: "Shantilal Khabiya",
      role: "AVP - R and D Operations",
      image: SKImage,
      bio: "Shantilal is a pharmaceutical operations specialist holding a Master's degree in Finance Administration. He possesses deep experience in the technocommercial aspects of formulation projects, logistics, and supply chain management. Highly structured and analytical, he ensures operational efficiency and strict project timeline adherence. Throughout his career, he has successfully overseen operational segments in collaborations with global entities like BASF, Novartis, Piramal, and Famy Care.",
    },
  ];

  return (
    <div className="bg-[#F7F9FA] min-h-screen text-slate-800">
      {/* 1. Header Hero Section */}
      <section className="relative min-h-[35vh] flex items-center justify-center pt-32 pb-16 overflow-hidden bg-brand-blue-deep">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 mix-blend-overlay"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&w=1920&auto=format&fit=crop')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-brand-blue-deep via-brand-blue/90 to-brand-blue/30" />
        <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center text-white z-10">
          <div className="inline-flex items-center space-x-2 bg-brand-teal/20 border border-brand-teal/30 rounded-full px-4 py-1.5 mb-4">
            <span className="text-brand-teal-light font-semibold text-xs uppercase tracking-wider">
              About Us
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-4">
            Delivering Differentiation & Innovation
          </h1>
          <p className="max-w-2xl mx-auto text-base md:text-lg text-slate-300 font-light leading-relaxed">
            Reducing the burden of healthcare by developing stable, reproducible, and affordable pharmaceutical formulations.
          </p>
        </div>
      </section>

      {/* 2. Company Overview Section */}
      <section className="py-20 max-w-7xl mx-auto px-6 md:px-12" id="overview">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Text block */}
          <div className="lg:col-span-7 space-y-6">
            <div className="inline-block text-xs font-semibold text-brand-teal uppercase tracking-widest bg-brand-teal/10 px-3 py-1 rounded-full">
              Who We Are
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue tracking-tight">
              We Are Different
            </h2>
            <div className="space-y-4 text-slate-600 leading-relaxed text-base md:text-lg font-light">
              <p>
                We are a research-driven, innovative pharmaceutical company focused on{" "}
                <span className="font-semibold text-brand-blue">
                  “Reducing the burden of Healthcare”
                </span>
                , through strategic alliances in formulation development and manufacturing support.
              </p>
              <p>
                We aim to reduce healthcare costs by providing simple, robust solutions to ever-challenging problems faced by generic and innovator companies. Our scientific team works to establish reliable, scalable, and reproducible processes that ensure highly stable and bioequivalent compositions.
              </p>
            </div>
          </div>
          {/* Image block */}
          <div className="lg:col-span-5 relative">
            <div className="absolute -inset-4 bg-brand-teal/10 rounded-2xl blur-lg transform rotate-2" />
            <div className="relative bg-white p-3 rounded-2xl shadow-xl border border-slate-100 overflow-hidden group">
              <img
                src={DelNovaHomeImage}
                alt="DelNova Research Lab"
                className="w-full h-[300px] md:h-[350px] object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 3. Mission & Vision Section */}
      <section className="py-16 bg-gradient-to-b from-[#F7F9FA] to-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Mission Card */}
          <div className="relative group bg-white border border-slate-100 hover:border-brand-teal/30 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-brand-teal/5 to-transparent rounded-tr-2xl" />
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-brand-teal/10 flex items-center justify-center text-brand-teal">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-brand-blue">Our Mission</h3>
            </div>
            <p className="text-2xl font-extrabold text-brand-blue tracking-tight leading-relaxed mb-4">
              “Reducing the burden of Healthcare.”
            </p>
            <p className="text-slate-600 font-light leading-relaxed">
              We seek to drive healthcare improvement around the world through exceptional technological partnership, research excellence, and reliable drug product design.
            </p>
          </div>

          {/* Vision Card */}
          <div className="relative group bg-white border border-slate-100 hover:border-brand-teal/30 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-brand-teal/5 to-transparent rounded-tr-2xl" />
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-brand-teal/10 flex items-center justify-center text-brand-teal">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-brand-blue">Our Vision</h3>
            </div>
            <p className="text-2xl font-extrabold text-brand-blue tracking-tight leading-relaxed mb-4">
              Value through innovation.
            </p>
            <p className="text-slate-600 font-light leading-relaxed">
              To become the most valued healthcare partners globally by providing advanced healthcare solutions guided by a firm commitment to science, quality, and affordability.
            </p>
          </div>
        </div>
      </section>

      {/* 4. Our Values Section */}
      <section className="py-20 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block text-xs font-semibold text-brand-teal uppercase tracking-widest bg-brand-teal/10 px-3 py-1 rounded-full mb-3">
            Core Principles
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue tracking-tight">
            Our Values
          </h2>
          <p className="text-slate-500 font-light mt-3">
            We are committed to adhering to our core values, ensuring that our partnership projects receive consistent quality and deliver sustainable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {values.map((v, i) => (
            <div
              key={i}
              className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-brand-teal-soft flex items-center justify-center mb-6">
                {v.icon}
              </div>
              <h4 className="text-lg font-bold text-brand-blue mb-3">{v.name}</h4>
              <p className="text-slate-500 text-xs font-light leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-brand-blue italic font-medium text-lg border-t pt-3 max-w-xl mx-auto border-slate-100">
            “It's not just what we do, it's the way that we do it.”
          </p>
        </div>
      </section>

      {/* 5. Team Section */}
      <section className="py-20 bg-slate-50 border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div className="inline-block text-xs font-semibold text-brand-teal uppercase tracking-widest bg-brand-teal/10 px-3 py-1 rounded-full mb-3">
              Leadership
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue tracking-tight">
              Our Core Team
            </h2>
            <p className="text-slate-500 font-light mt-3">
              Meet the specialists leading DelNova's pharmaceutical formulation research and commercial operations.
            </p>
          </div>

          {/* Row 1: Vijayendra and Shweta */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {team.slice(0, 2).map((member, idx) => (
              <div
                key={idx}
                className="bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 group flex flex-col"
              >
                {/* Image & Overlay */}
                <div className="relative h-[320px] overflow-hidden bg-white flex-shrink-0 border-b border-slate-100">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-102"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-blue-deep/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                    <button
                      onClick={() => setSelectedMember(member)}
                      className="bg-white text-brand-blue font-semibold text-xs py-2.5 px-5 rounded-full shadow-md hover:bg-brand-teal hover:text-white transition-colors duration-200 transform hover:scale-[1.05]"
                    >
                      View Biography
                    </button>
                  </div>
                </div>
                {/* Member Info */}
                <div className="p-6 text-center flex-grow flex flex-col justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-brand-blue">{member.name}</h3>
                    <p className="text-xs text-brand-teal font-medium uppercase tracking-wider mt-1">{member.role}</p>
                  </div>
                  <button
                    onClick={() => setSelectedMember(member)}
                    className="mt-6 text-slate-500 hover:text-brand-teal text-xs font-semibold inline-flex items-center justify-center space-x-1 border-t pt-4 border-slate-50 group-hover:border-slate-100 transition-colors"
                  >
                    <span>Read Bio</span>
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Row 2: Shantilal Khabiya (Moved to next line, centered, and slightly smaller) */}
          <div className="mt-8 flex justify-center">
            <div className="bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 group flex flex-col w-full max-w-[320px]">
              {/* Image & Overlay */}
              <div className="relative h-[255px] overflow-hidden bg-white flex-shrink-0 border-b border-slate-100">
                <img
                  src={team[2].image}
                  alt={team[2].name}
                  className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-102"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-blue-deep/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                  <button
                    onClick={() => setSelectedMember(team[2])}
                    className="bg-white text-brand-blue font-semibold text-xs py-2.5 px-5 rounded-full shadow-md hover:bg-brand-teal hover:text-white transition-colors duration-200 transform hover:scale-[1.05]"
                  >
                    View Biography
                  </button>
                </div>
              </div>
              {/* Member Info */}
              <div className="p-6 text-center flex-grow flex flex-col justify-between">
                <div>
                  <h3 className="text-lg font-bold text-brand-blue">{team[2].name}</h3>
                  <p className="text-xs text-brand-teal font-medium uppercase tracking-wider mt-1">{team[2].role}</p>
                </div>
                <button
                  onClick={() => setSelectedMember(team[2])}
                  className="mt-6 text-slate-500 hover:text-brand-teal text-xs font-semibold inline-flex items-center justify-center space-x-1 border-t pt-4 border-slate-50 group-hover:border-slate-100 transition-colors"
                >
                  <span>Read Bio</span>
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Biography Modal */}
      {selectedMember && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300">
          <div
            className="fixed inset-0"
            onClick={() => setSelectedMember(null)}
          />
          <div className="relative bg-white w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden border border-slate-100 z-10 flex flex-col md:flex-row max-h-[90vh] animate-scale-up">
            {/* Modal Left / Portrait */}
            <div className="w-full md:w-2/5 h-[280px] md:h-auto relative bg-white flex-shrink-0 border-r border-slate-50">
              <img
                src={selectedMember.image}
                alt={selectedMember.name}
                className="w-full h-full object-contain p-6"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/5 md:from-transparent to-transparent pointer-events-none" />
            </div>

            {/* Modal Right / Details */}
            <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col overflow-y-auto">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-brand-blue">{selectedMember.name}</h3>
                  <p className="text-xs md:text-sm text-brand-teal font-semibold uppercase tracking-wider mt-1">{selectedMember.role}</p>
                </div>
                <button
                  onClick={() => setSelectedMember(null)}
                  className="p-1 rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors focus:outline-none"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Bio content */}
              <div className="text-slate-600 font-light leading-relaxed text-sm md:text-base space-y-4 flex-grow">
                <p>{selectedMember.bio}</p>
              </div>

              {/* Close Button Footer */}
              <div className="mt-8 border-t pt-4 flex justify-end">
                <button
                  onClick={() => setSelectedMember(null)}
                  className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold text-xs py-2 px-5 rounded-full transition-colors duration-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
